export default defineNuxtPlugin(() => {
  const { validateSession } = useSessionGuard();
  let isCheckingSession = false;

  const runSessionCheck = async () => {
    if (isCheckingSession) {
      return;
    }

    isCheckingSession = true;

    try {
      await validateSession();
    } finally {
      isCheckingSession = false;
    }
  };

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      runSessionCheck();
    }
  };

  window.addEventListener('focus', runSessionCheck);
  document.addEventListener('visibilitychange', onVisibilityChange);

  runSessionCheck();
});
